<template>
  <div class="con">
    <mt-tabbar :class="{'mt-custom': isIphoneX}">
      <mt-tab-item id="个人文件">
        <router-link :to="{path:'/index'}" class="tab-link" tag="div">
            <span :class="{color:id===1}">
              <i class="iconfont icon-file-text" v-show="id===1"></i>
              <i class="iconfont icon-file-text" v-show="id!==1"></i>
              <!--<img slot="icon" src="../assets/images/personal-n.png" v-show="id===1">-->
              <!--<img slot="icon" src="../assets/images/personal.png" v-show="id!==1">-->
              个人文件
            </span>
        </router-link>
      </mt-tab-item>
      <mt-tab-item id="共享文件">
        <router-link :to="{path:'/shareFile'}" class="tab-link" tag="div">
            <span :class="{color:id===2}">
               <i class="iconfont icon-usergroup" v-show="id===2"></i>
               <i class="iconfont icon-usergroup" v-show="id!==2"></i>
              共享文件
            </span>
        </router-link>
      </mt-tab-item>
      <mt-tab-item id="传输">
        <router-link :to="{path:'/transfer'}" class="tab-link" tag="div">
            <span :class="{color:id===3}">
              <i class="iconfont icon-chuanshu" v-show="id===3"></i>
              <i class="iconfont icon-chuanshu" v-show="id!==3"></i>
              传输
            </span>
        </router-link>
      </mt-tab-item>
      <mt-tab-item id="更多">
        <router-link :to="{path:'/more/setinfo'}" class="tab-link" tag="div">
            <span :class="{color:id===4}">
              <i class="iconfont icon-gengduo" v-show="id===4"></i>
              <i class="iconfont icon-gengduo" v-show="id!==4"></i>
              更多
            </span>
        </router-link>
      </mt-tab-item>
    </mt-tabbar>
  </div>
</template>
<script>
  //  import GetQueryString from '../assets/js/tools'
  export default {
    name: 'tabbar',
    data () {
      return {
        isIphoneX: false
      }
    },
    props: ['id'],
    methods: {},
    created () {
      let isx = this.$store.state.isIphoneX
      this.isIphoneX = isx
    }
  }
</script>
<style lang="scss" scoped>
  .color {
    /*color: #E4393C;*/
  }
  .tab-link{
    color: #7f8389;
  }
  .iconfont{
    font-size: .48rem;
    display: block;
  }
  .mint-tab-item {
    padding: .1rem .2rem!important;
  }
  .mint-tabbar {
    position: fixed!important;
     bottom: 0;
  }
  .router-link-active {
      color: #E4393C;
  }
  .mt-custom {
    height: 1.64rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/tabbar.vue